
import format from 'date-fns/format'

const filters = {
  second2Date: (sec) => {
    return format(sec * 1000, 'yyyy-MM-dd HH:mm:ss')
  }
}

export default filters
